import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";
import { toast } from "react-toastify";
import InventoryCard from "../components/InventoryCard";
import StatsGrid from "../components/StatsGrid";
import "../components/StatisticsPageStyle.css";

const StatisticsPage = () => {
  const [loading, setLoading] = useState(true);
  
  // نفترض أن الـ Backend يرسل البيانات بهذا الشكل الجاهز
  const [statsData, setStatsData] = useState({
    totalOrders: 0,
    activeOrders: 0,
    completedOrders: 0,
    usedMeters: 0,
    totalCapacity: 0,
    ordersByStatus: {},
    ordersByCategory: {}
  });

  const fetchStats = useCallback(async () => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/statistics`);
    setStatsData(res.data);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await fetchStats();
      } catch (error) {
        toast.error("فشل في تحميل الإحصائيات ❌");
      } finally {
        setLoading(false);
      }
    })();
  }, [fetchStats]);

  // دالة لتحديث سعة المخزن (يتم تمريرها للـ Child Component)
  const handleUpdateCapacity = async (newCapacity) => {
    try {
      await axiosInstance.patch(`${process.env.REACT_APP_API_URL}/stores/capacity`, {
        totalCapacity: newCapacity
      });
      
      // تحديث الواجهة محلياً بعد نجاح السيرفر
      // setStatsData((prev) => ({ ...prev, totalCapacity: newCapacity }));
      await fetchStats();

      toast.success("تم تحديث سعة المخزن بنجاح ✅");
      return true; // نرجع true ليغلق الـ Input
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error("السعة الجديدة لا يمكن أن تكون أقل من الأمتار المستخدمة حالياً ❌");
        } else if (error.response.status === 403) {
          toast.error("ليس لديك صلاحية لتحديث سعة المخزن ❌");
        } else if (error.response.status === 422) {
          toast.error("البيانات المدخلة غير صحيحة ❌");
        } else if (error.response.status === 500) {
          toast.error("خطأ في الخادم، حاول مرة أخرى لاحقاً ❌");
        } else {
          toast.error("حدث خطأ أثناء تحديث السعة ❌");
        }} else if (error.request) {
          toast.error("خطأ في الاتصال بالخادم ⚠️");
        } else {
          toast.error("حدث خطأ غير متوقع، حاول مرة أخرى ❌");
        }
      return false;
  };
}

  if (loading) return <div className="loading-screen">جاري تحميل البيانات...</div>;

  return (
    <div className="stats-page-container">

      {/* الجزء الأيمن: تفاصيل الطلبات */}
      <StatsGrid 
        total={statsData.totalOrders}
        active={statsData.activeOrders}
        completed={statsData.completedOrders}
        byStatus={statsData.ordersByStatus}
        byCategory={statsData.ordersByCategory}
      />

            {/* الجزء الأيسر: المخزن */}
      <InventoryCard 
        usedMeters={statsData.usedMeters}
        usagePercentage={statsData.usagePercentage}
        availableMeters={statsData.available_meters}
        totalCapacity={statsData.totalCapacity}
        onUpdateCapacity={handleUpdateCapacity}
      />
      
    </div>
  );
};

export default StatisticsPage;